const getters = {
  sidebar: (state) => state.app.sidebar,

  name: (state) => state.user.info.real_name,
  username: (state) => state.user.info.username,
  user_id: (state) => state.user.info.id,
  email: (state) => state.user.info.email,
  userInfo: (state) => state.user.info,
  roles: (state) => state.user.roles,

  category: (state) => state.options.category,
  country: (state) => state.options.country,
  material_options: (state) => state.options.materialOptions,
  languages: (state) => state.config.languages,
  vmakerSetting: (state) => state.options.vmakerSetting,
  designer: (state) => state.options.designer,
  demander: (state) => state.options.demander,
  account_mgr: (state) => state.options.accountMgr,
  developer: (state) => state.options.developer,
  tester: (state) => state.options.tester,
  appCategory: (state) => state.options.appCategory,
  advertisers: (state) => state.options.advertisers,
  fontList: (state) => state.config.fontList,
  planner: (state) => state.options.planner,

  permission_routers: (state) => state.permission.routers,
  accessibleRouters: (state) => state.permission.accessibleRouters,
  currentRouter: (state) => state.permission.currentRouter,
}
export default getters
